<div class="reference_body">
  <main class="reference_main">
    <div class="pink_box"></div>
    <div class="green_box"></div>

    <div class="main">

   <div class="reference_table">
    <div class="container">

      <div class="gmou" style="display: flex; flex-direction: column;">
        <div class="the_header_progress">
          <div class="row">

             <div class="col-md-9">
              <h3 class="header" style="margin-bottom: 1rem;">Create Project</h3>
              <div class="row mt-5 mb-3">
                <div class="col-md-6">
                  <h3>Project Category</h3>
                  <span class="gmou_class">{{GmouData?.GMOUCategoryId}}</span>
                </div>
                <div class="col-md-6">
                  <h3>GMOU Name</h3>
                  <span>{{GmouData?.GMOUTitle}}</span>
                </div>
              </div>
             </div>

              <div class=" col-md-3">
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" color="accent" class="m-3">

                  <mat-button-toggle value="grid" (click)="onBack()"><mat-icon class="example-tab-icon">arrow_back</mat-icon> Back</mat-button-toggle>
                  <mat-button-toggle mat-raised-button value="grid" color="primary" (click)="filterProjectModal()"><mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</mat-button-toggle>
                </mat-button-toggle-group>
                <!-- <button mat-raised-button color="primary"  (click)="filterProjectModal()"> <mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</button> -->
               </div>

          </div>
        </div>


      <form [formGroup]="projectForm">

      <div class="monitor_project_drop" style="margin-top: 10px;">


          <div class="other_details" *ngIf="status" [@fadeInAnimation]>
            <div class="the_card">
              <div class="detail__info">
                <h4 class="label">
                    <span class="labels" style="display: block;">State</span>
                    <!-- <span class="the__input">{{GmouData?.StateId}}</span> -->
                    <div class="the__input" *ngFor="let data of GmouData?.States">
                      <span class="mt-2">{{data?.StateName}}</span>
                    </div>
                </h4>
            </div>
            <div class="detail__info">
                <h4 class="label">
                    <span class="labels" style="display: block;">LGA</span>
                    <div class="the__input" *ngFor="let data of GmouData?.Lgas">
                      <span class="mt-2">{{data?.LgaName}}</span>
                    </div>
                </h4>
            </div>
            <div class="detail__info">
                <h4 class="label">
                    <span class="labels" style="display: block;" *ngIf="genericBlockLabel">{{genericBlockLabel}}</span>
                    <div class="the__input" *ngFor="let oilBlock of GmouData?.OilBlocks">
                      <span class="mt-2">{{oilBlock?.OilBlockName}}</span>
                    </div>
                </h4>
            </div>
            <div class="detail__info">
                <h4 class="label">
                    <span class="labels" style="display: block;" *ngIf="genericFieldLabel">{{genericFieldLabel}}</span>
                    <div class="the__input" *ngFor="let oilField of GmouData?.OilFields">
                      <span class="mt-2">{{oilField?.OilFieldName}}</span>
                    </div>
                </h4>
            </div>
            </div>

           <div class="row">

            <div class="col-md-6">

                <mat-form-field class="full-width-field" id="id_number">
                  <input matInput placeholder="Enter Project Title" formControlName="ProjectTitle"  >

                  <mat-error *ngIf="errorHandling('ProjectTitle', 'required')">
                     You must provide <strong>Project title</strong>
                  </mat-error>
               </mat-form-field>

            </div>

           <div class="col-md-6">

            <div class="row">
              <div class="col-md-7">
                <mat-form-field class="full-width-field" id="id_number">
                  <input matInput type="number" placeholder="Enter Budget" formControlName="Budget"  >

                  <mat-error *ngIf="errorHandling('Budget', 'required')">
                     You must provide <strong>Budget</strong>
                  </mat-error>
               </mat-form-field>
              </div>

              <div class="col-md-5">
                <mat-form-field class="full-width-field" id="id_number">
                  <mat-label>Select Currency</mat-label>

                  <mat-select formControlName="CurrencyId" >
                    <mat-option>-- None --</mat-option>
                      <mat-option *ngFor="let currency of currencies" [value]="currency.id">
                        {{currency.CurrencyName}}
                      </mat-option>

                  </mat-select>
                </mat-form-field>
               </div>
            </div>

           </div>


           </div>

            <div class="row">
              <div class="col-md-12">
                  <mat-form-field class="full-width-field" id="id_number">
                    <textarea matInput placeholder="Enter Description" rows="2" formControlName="Description"  ></textarea>

                    <mat-error *ngIf="errorHandling('Description', 'required')">
                       You must provide <strong> Description</strong>
                    </mat-error>
                 </mat-form-field>
              </div>
            </div>

            <div class=" row">

            <div class="col-md-6">
              <mat-form-field class="full-width-field" id="id_number">
                <mat-label>Select Project Executor</mat-label>

                <mat-select formControlName="Executor" >
                  <mat-option>-- None --</mat-option>
                    <mat-option *ngFor="let user of users" [value]="user.name">
                      {{user.name}}
                    </mat-option>

                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-3">

                  <mat-form-field class="full-width-field" id="id_number">

                    <input matInput [matDatepicker]="picker" formControlName="StartDate" placeholder="Select Start Date">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-hint></mat-hint>

                               <mat-error *ngIf="errorHandling('StartDate', 'required')">
                                  You must provide <strong>start date</strong>
                               </mat-error>
                            </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field class="full-width-field" id="id_number">

                <input matInput [matDatepicker]="picker1" formControlName="EndDate" placeholder="Select End Date">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <mat-hint></mat-hint>

                    <mat-error *ngIf="errorHandling('EndDate', 'required')">
                       You must provide <strong>End Date </strong>
                    </mat-error>
                 </mat-form-field>
            </div>
            </div>
            <!-- <pre>{{projectManagements | json}}</pre> -->

            <div class="container" style="text-align: center; width:100%;">
                <button class="top__button mt-5" type="submit" (click)="onSubmit(projectForm.value)" [disabled]="projectForm.invalid" >Submit</button>
            </div>
        </div>


      </div>
    </form>

      <div class="container"
          style="text-align:right; width:95%; margin-top: 3rem; margin-bottom: 0.5rem; padding-left: 3rem; border-top:1px solid rgb(192, 192, 192);" *ngIf="status">
          <button class="new__activity mt-5" (click)="openCreateActivityModal()">Create activity</button>
      </div>



  </div>
</div>
   </div>
      </div>

  </main>
</div>

